import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { Button } from "../components/ui/button";
import { CheckCircle2 } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const [status, setStatus] = useState("pending");
  const nav = useNavigate();

  useEffect(() => {
    if (!sid) return;
    let stop = false, timer, attempts = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (stop) return;
        setStatus(data.payment_status);
        if (data.payment_status === "paid") return;
      } catch (err) {
        if (err.response?.status === 404) { setStatus("unknown"); return; }
        console.error("Payment status check failed", err);
      }
      if (stop) return;
      if (++attempts < 15) timer = setTimeout(poll, 2000);
      else setStatus("unknown");
    };
    poll();
    return () => { stop = true; clearTimeout(timer); };
  }, [sid]);

  return (
    <div data-testid="payment-success-page" className="max-w-xl mx-auto px-6 py-24 text-center">
      <CheckCircle2 size={64} strokeWidth={1.5} className="mx-auto" style={{color: "var(--accent-metal)"}}/>
      <h1 className="font-serif text-5xl mt-6 leading-none" style={{color: "var(--primary)"}}>{status === "paid" ? "Thank you." : status === "unknown" ? "We couldn't confirm yet." : "Confirming payment…"}</h1>
      <p className="mt-4 text-[color:var(--text-muted)]">{status === "paid" ? "Your order is confirmed. We'll email a proof within one business day." : status === "unknown" ? "Your payment may still be processing. Check your dashboard in a few minutes, or contact us if it doesn't appear." : "Please hold — verifying with the payment processor."}</p>
      <div className="mt-8 flex gap-3 justify-center">
        <Button data-testid="go-dashboard" onClick={() => nav("/dashboard")} className="btn-primary rounded-full px-7 py-6">View orders</Button>
      </div>
    </div>
  );
}
